// sortHandlerMixin.js

export const sortHandlerMixin = {
  data () {
    return {
      sortDirection: {
        name: 'default',
        time: 'default',
        amount: 'default',
        number: 'default'
      }
    }
  },
  methods: {
    handleSort (sortFormat) {
      if (
        this.sortDirection[sortFormat] === 'desc' ||
        this.sortDirection[sortFormat] === 'default'
      ) {
        this.sortDirection[sortFormat] = 'asc'
      } else {
        this.sortDirection[sortFormat] = 'desc'
      }
      const sortObj = {
        sortFormat,
        direction: this.sortDirection[sortFormat]
      }

      this.$emit('sort', sortObj)
      // Set other possible sortFormat(s) to default state
      if (sortFormat === 'name') {
        this.sortDirection.time = 'default'
        this.sortDirection.amount = 'default'
        this.sortDirection.number = 'default'
      } else if (sortFormat === 'time') {
        this.sortDirection.name = 'default'
        this.sortDirection.amount = 'default'
        this.sortDirection.number = 'default'
      } else if (sortFormat === 'amount') {
        this.sortDirection.name = 'default'
        this.sortDirection.time = 'default'
        this.sortDirection.number = 'default'
      } else if (sortFormat === 'number') {
        this.sortDirection.name = 'default'
        this.sortDirection.time = 'default'
        this.sortDirection.amount = 'default'
      }
    },
    resetSortDirection () {
      this.sortDirection.name = 'default'
      this.sortDirection.time = 'default'
      this.sortDirection.amount = 'default'
      this.sortDirection.number = 'default'
    }
  }
}
